import find from 'lodash/find'
import map from 'lodash/map'
import forIn from 'lodash/forIn'
import throttle from 'lodash/throttle'

import utils from '../utils'
import appUtils from '../app_utils'

import parallaxHeader from './parallax_header'
// import section3d from './section_3d'
// import sectionOddeven from './section_oddeven'
import sectionProduct from './section_product'
import sectionRange from './section_range'
// import sectionScrollgroup from './section_scrollgroup'
import sectionContactUs from './section_contact-us';
// import sectionPerformance from './section_performance';
import sectionDecor from './section_decor';

// https://github.com/verlok/vanilla-lazyload
import LazyLoad from 'vanilla-lazyload'

const layerLazySelector = '[data-sections-lazy]'

/*
  fix mobile jump on scroll
*/
// https://github.com/greensock/GSAP/issues/477#issuecomment-998567478
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// https://greensock.com/docs/v3/Plugins/ScrollTrigger/static.config()
ScrollTrigger.config({
  // default: visibilitychange,DOMContentLoaded,load,resize
  autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load',
  // ignoreMobileResize: true, // added in 3.10.0 if true, vertical resizes (of 25% of the viewport height) on touch-only devices won't trigger a ScrollTrigger.refresh(), avoiding the jumps that can happen when the start/end values are recalculated.
})
let windowHg = window.innerHeight
let windowWd = window.innerWidth
const isTouch = appUtils.isTouch() // (matchMedia('(hover: none)').matches

let resizingTimer = null
let resizingBoolean = false
const onWindowResize = function(){
  const hg = window.innerHeight
  const wd = window.innerWidth
  // $('.message').text(Math.abs(hg - windowHg) + ' ' + Math.abs(wd - windowWd) + ' ' + appUtils.isTouch())
  const dHg = Math.abs(hg - windowHg)
  const dWd = Math.abs(wd - windowWd)
	windowHg = hg
	windowWd = wd

  if (dHg < 150 && dWd === 0 && isTouch && !resizingTimer) {
    // do nothing to prevent mobile jump
  } else {
    // scroll to top on subsequent calls! (works better for fast resizes)
    // window.scrollTo(0, 0)
    if (resizingTimer) {
      clearTimeout(resizingTimer)
      resizingTimer = null
    } else {
      appUtils.overlayOn()

      ScrollTrigger.clearScrollMemory() // Clears any recorded scroll positions in ScrollTrigger so that no scroll positions get restored after a refresh()
      // appUtils.scrollLock()
      window.scrollTo(0, 0) // better recalc
    }
    resizingBoolean = true
    resizingTimer = setTimeout(()=>{

      ScrollTrigger.clearScrollMemory() // Clears any recorded scroll positions in ScrollTrigger so that no scroll positions get restored after a refresh()
      window.scrollTo(0, 0) // better recalc
      // https://greensock.com/docs/v3/Plugins/ScrollTrigger/static.refresh()
      ScrollTrigger.refresh() // pass true to wait one requestAnimationFrame
      // appUtils.scrollUnlock(false)
      resizingTimer = setTimeout(()=>{
        // ScrollTrigger.refresh() // pass true to wait one requestAnimationFrame
        appUtils.overlayOff()
        resizingBoolean = false
        resizingTimer = null
        if (activeSectionElement) {
          if (activeSectionElement.getAttribute('data-tl-label')) {
            const label = activeSectionElement.getAttribute('data-tl-label')
            const $parentScrollGroupElem = $(activeSectionElement).parents('[data-section-scrollgroup]')
            if ($parentScrollGroupElem.length) {
              const sectionInstance = sectionInstances[parseInt($parentScrollGroupElem.data('data-section-scrollgroup'), 10)]
              if (sectionInstance.tl) {
                return gsap.to(window, {duration: 0, scrollTo: sectionInstance.tl.scrollTrigger.labelToScroll(label)})
              }
            }
          }
          // window.scrollTo(0, $(activeSectionElement).offset().top)
          appUtils.scrollTo($(activeSectionElement), undefined, 0 )
        }
      }, 100)
    }, 800)
  }
}
const onWindowResizeThrottle = throttle(onWindowResize, 200)

const appInit = function() {
  //window.addEventListener('resize', onWindowResize)
  appUtils.$window.on('resize', onWindowResizeThrottle)
}

const appDestroy = function() {
  //window.removeEventListener('resize', onWindowResize)
  appUtils.$window.off('resize', onWindowResizeThrottle)
}

/*
  End fix mobile jump on scroll
*/


let sectionInstances = []
let activeSectionElement = null

// section3d, sectionOddeven, sectionScrollgroup, sectionPerformance,
const sections = [parallaxHeader, sectionProduct, sectionRange,  sectionContactUs, sectionDecor]
let sectionsDataArr = []
sections.forEach((item, i) => {
  sectionsDataArr.push('[' + item.dataAttr + ']')
});

const getAttributesObject = function(node) {
  const attributeNodeArray = [...node.attributes];
  const attrs = attributeNodeArray.reduce((attrs, attribute) => {
   attrs[attribute.name] = attribute.value;
   return attrs;
  }, {});
  return attrs;
 }

appUtils.$body.prepend('<div class="progress-bar-wrapper"><div class="progress-bar"></div></div>')
const progressBar = document.querySelector('.progress-bar')
let lazyLoadInstance
// https://stackoverflow.com/questions/1366127/how-do-i-make-javascript-object-using-a-variable-string-to-define-the-class-name
const init = function() {
  appUtils.$body.removeClass('sections-ready')
  appUtils.scrollLock([0, 0])
  // appUtils.overlayOn()

  // https://github.com/verlok/vanilla-lazyload
  let loadedCount = 0
  const loadedCountTotal = document.querySelectorAll(layerLazySelector).length
  lazyLoadInstance = new LazyLoad({
      callback_loaded: (el)=>{
        // lazyLoadInstance.loadingCount
        // lazyLoadInstance.toLoadCount
        loadedCount ++
        progressBar.style.width = (loadedCount / loadedCountTotal * 100) + '%'
      },
      callback_finish: sectionsInit,
      elements_selector: layerLazySelector
  })
  if (loadedCountTotal) {
    lazyLoadInstance.loadAll()
  } else {
    sectionsInit()
  }

}

const setActiveSection = function(event, entry){
  if (!resizingBoolean) { // if not resizing, set the current active section, restored afetr resize
    activeSectionElement = entry.target
    // console.log(activeSectionElement)
    let sectionId = activeSectionElement.getAttribute('id')
    if (sectionId && appUtils.$navBox) {
      appUtils.$navBox.find('.active').removeClass('active')
      appUtils.$navBox.find('[href="#' + sectionId + '"]').parent('li').addClass('active')
    }
  }
}

const sectionsInit = function() {
  appUtils.$body.addClass('sections-ready')
  appUtils.scrollUnlock()
  // appUtils.overlayOff()

  appUtils.$window.on('set-active-section', setActiveSection)

  $(sectionsDataArr.join(',')).each(function(index) {
    const elem = this
    const attributes = getAttributesObject(this)
    forIn(attributes, (value, key) => {
      const sectionItem = find(sections, function(o) { return o.dataAttr === key })
      if (sectionItem) {
        const spInstance = new sectionItem.sectionClass(elem, {index: index})
        sectionInstances.push(spInstance)

        // save the instance index, so instance is garbage collected on page detroy
        $(elem).data(key, sectionInstances.length - 1)
      }
    })
  })
}

const destroy = function() {
  lazyLoadInstance.destroy()

  sectionInstances.forEach(spInstance => {
    spInstance.destroy()
  })
  sectionInstances = []

  appUtils.$window.off('set-active-section', setActiveSection)
}

export default {init, destroy, appInit, appDestroy}
